import React, { useEffect } from 'react';
import {useDropzone} from 'react-dropzone';

const thumbsContainer = {
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
};

const thumb = {
  display: 'inline-flex',
  width: 'max-content',
  height: 'max-content',
  boxSizing: 'border-box'
};

const thumbInner = {
  display: 'flex',
  minWidth: 0,
  overflow: 'hidden',
  justifyContent: 'space-around'
};

const img = {
  display: 'block',
  maxWidth: '100%',
  borderRadius: 4
};

const dropzone = {
  justifyContent: 'center',
  color: '#ABBCD5'
}

function PreviewDropzone({classes='', files, setFiles, imgUrl=''}) {
  const {getRootProps, getInputProps} = useDropzone({
    accept: {
      'image/*': [],
    },
    onDrop: acceptedFiles => {
      setFiles(acceptedFiles.map(file => Object.assign(file, {
        preview: URL.createObjectURL(file)
      })));
    }
  });

  const thumbs = files.map(file => (
    <div style={thumb} key={file.name}>
      <div style={thumbInner}>
        <img
          src={file.preview}
          style={img}
          // Revoke data uri after image is loaded
          onLoad={() => { URL.revokeObjectURL(file.preview) }}
        />
      </div>
    </div>
  ));

  // Workaround to avoid browser caching bug
  const imageName = imgUrl + '?dummy=' + Math.random().toString();

  const thumbFromImgUrl = (
    <div style={thumb} key={imgUrl}>
      <div style={thumbInner}>
        <img
          src={imageName}
          style={img}
          // Revoke data uri after image is loaded
          // onLoad={() => { URL.revokeObjectURL(file.preview) }}
        />
      </div>
    </div>
  );

  const classList = "form-control-flush p-0 mb-6 col-md-8" + classes;

  useEffect(() => {
    // Make sure to revoke the data uris to avoid memory leaks, will run on unmount
    return () => files?.forEach(file => URL.revokeObjectURL(file.preview));
  }, []);

  return (
    <section className={classList}>
      <div style={dropzone} {...getRootProps({className: 'dropzone'})}>
        <input {...getInputProps()} />
        { files?.length === 0 && imgUrl === '' ?
          <>
            <i className="fa fa-3x fa-camera mb-4" aria-hidden="true"></i>
            <p className='text-center mb-0'>Drag & drop or click to add image</p>
            <p className='text-center'> JPEG or PNG, no larger than 5MB</p>
          </>
          :
          <aside style={thumbsContainer}>
            {files.length > 0 ? thumbs : thumbFromImgUrl}
          </aside>
        }
      </div>
    </section>
  );
}

export default PreviewDropzone;
